export class Tab {
  public id: string;
  public label: string;
  public contentId: string;
  public icon: string;
  public isOpen: boolean;
  public confirmBeforeClose: boolean;
  public canClose = true;
  public color: string;
  public enable = true;
  private _route: string | null = null;

  constructor(
    id: string,
    label: string,
    contentId: string,
    icon?: string,
    isOpen?: boolean,
    confirmBeforeClose?: boolean,
    color?: string,
  ) {
    this.id = id;
    this.label = label;
    this.contentId = contentId;
    this.icon = icon;
    this.isOpen = isOpen === null || isOpen === undefined || isOpen;
    this.confirmBeforeClose = confirmBeforeClose;
    this.color = color;
  }

  public get route(): string | null {
    return this._route;
  }

  public set route(value: string | null) {
    if (value !== null && value.startsWith('/')) {
      value = value.substring(1);
    }
    this._route = value;
  }
}
